<div
  class="cet-instruction-steps-container"
  [class.arabic]="!isLeft"
  *ngIf="instruction"
>
  <div class="instruction-item">
    <div class="text" [class.background-none]="!background">
      <span class="numeric" *ngIf="!completed && !showLogo">{{ index }}</span>
      <span class="check" *ngIf="completed">
        <img src="assets/images/check.svg" alt="completed"/>
      </span>
      <span *ngIf="showLogo" class="logo">
        <img src="assets/images/logo.webp" width="28px" height="30px" alt="Tas'heel"/>
      </span>

      <span [class.no-icon]="!icon"
            [ngStyle]="page_sayen === 'sayen' ? { 'cursor': 'pointer' } : {}"
            class="instruction-text"
            [class.sayen-cursor-pointer]="page_sayen === 'sayen'"
            (click)="checkSayenPage()"
      >{{ instruction }}</span>
    </div>

    <div class="icon" (click)="iconClickedEvent($event)" *ngIf="icon"
        [class.first]="index==1"
        [class.completed]="index==1"
        [class.completed]="completed"
        [class.prevCompleted]="prevCompleted"
      >
      <img [src]="icon" alt="icon" style="max-width: 85%; pointer-events: none;" *ngIf="!loading"  />
      <img
        src="assets/images/rolling.webp"
        alt="loading"
        *ngIf="loading"
        style="max-width: 25px"
      />
    </div>
  </div>
</div>
